import React from 'react'
import PropTypes from 'prop-types'
import { Col, Container, Row } from 'react-bootstrap'

// !COMPONENTS
import Layout from '@shared/components/layout'
import ChessInterestingReads from '@shared/components/chessComponents/chessIntrestingReads'
import ChessPlayers from '@shared/components/chessComponents/players'
import MyImage from '@shared/components/myImage'
import sPartner from '@assets/images/hil/sPartner.png'
import sPartnerMweb from '@assets/images/hil/sPartnerMweb.png'

import queryGraphql from '@shared/components/queryGraphql'
import { GET_CATEGORY_NEWS_VIDEOS } from '@graphql/series/home.query'
import { handleApiError, parallelCalls } from '@shared-submodule/utils'
import styles from './style.module.scss'
// import GoogleAds from '@shared-submodule/sm-components/googleAds'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
import useWindowSize from '@shared/hooks/windowSize'
import HockeyHeader from '@shared/components/HILComponents/hockeyHeader'
import HILInfo from '@shared/components/HILComponents/hilInfo'
import HilTable from '@shared/components/HILComponents/hilTable'
import VenueMweb from '@shared/components/HILComponents/venueMweb'
import BlogsNews from '@shared/components/olympics/blogsNews'
import HILMatches from '@shared/components/HILComponents/hilMatch'
import HILTimeLine from '@shared/components/HILComponents/hilTimeline'
import HILTeamsMweb from '@shared/components/HILComponents/hilTeamsMweb'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import dynamic from 'next/dynamic'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'
import { GRAPHQL_URL } from '@shared-submodule/sm-constants'

const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })

function HIL({ news, seoData, playerData, league, fixtureData, preViousWinnersData, teamData, editorPick }) {
  const [width] = useWindowSize()
  const data = news?.listSimpleCategoryArticlesVideosFront?.oArticles
  const editorPickData = editorPick?.listSimpleCategoryArticlesVideosFront?.oArticles

  const { addLeft } = reviveAdData
  return (
    <Layout
      data={{
        oSeo: seoData?.getSeoData
      }}>
      <>
        <HockeyHeader />
        <Container>
          <div className="d-flex flex-column pt-4">
            <Row className={`${styles.gap} mb-4`}>
              <Col xxl={3} className={`${styles.order} d-xxl-block d-none`}>
                {<HILInfo />}
              </Col>
              <Col xl={8} xxl={6} className={`${styles.centerContent}`}>
                <HILMatches fixtureData={fixtureData} />
              </Col>
              <Col xl={4} xxl={3} className="common-sidebar mt-0">
                <HilTable teamData={teamData} />
                {width > 767 && (
                  <a href="https://www.sonyliv.com" target="blank" className="d-flex my-3 justify-content-center w-100">
                    <MyImage src={sPartner} />
                  </a>
                )}
              </Col>
            </Row>
            {width < 767 && (
              <>
                <div className="mb-4">
                  <h4 className="font-bold">Venues</h4>
                  <VenueMweb />
                </div>
                <a href="https://www.sonyliv.com" target="blank" className="d-flex justify-content-center w-100">
                  <MyImage src={sPartnerMweb} />
                </a>
              </>
            )}
            {width > 767 && <ChessInterestingReads data={editorPickData?.aResults} />}
            {<HILTimeLine data={preViousWinnersData} teamData={teamData} />}
            {width < 767 && (
              <>
                <ChessInterestingReads data={editorPickData?.aResults} />
                <HILTeamsMweb teamData={teamData} />
              </>
            )}
            <ChessPlayers data={playerData} isHockey />
            {data?.aResults && <BlogsNews isHockey data={data?.aResults} />}
            {width < 767 && (
              // <GoogleAds
              //   addId={googleAddData?.mobLg?.addId}
              //   divId={googleAddData?.mobLg?.divId}
              //   dimension={googleAddData?.mobLg?.dimension}
              //   slotId={googleAddData?.mobLg?.slotId}
              //   className={'mt-0 mb-4'}
              // />
              <ReviveAds {...addLeft} className={'mt-0 mb-4'} />
            )}
          </div>
        </Container>
      </>
    </Layout>
  )
}

export async function getServerSideProps({ res, resolvedUrl }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=600')
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: 'hockey-india-league' } })
    const baseUrl = GRAPHQL_URL.replace(/\/graphql$/, '')
    const commonPayload = {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json'
      }
    }

    const fixtureResponse = await fetch(`${baseUrl}/api/global-widget/fixtures?limit=60`, commonPayload)
    const { data: fixtureData } = await fixtureResponse.json()
    const preViousWinnersResponse = await fetch(`${baseUrl}/api/global-widget/previous-winners`, commonPayload)
    const { data: preViousWinnersData } = await preViousWinnersResponse.json()
    const teamResponse = await fetch(`${baseUrl}/api/global-widget/teams`, commonPayload)
    const { data: teamData } = await teamResponse.json()
    const playerResponse = await fetch(`${baseUrl}/api/global-widget/top-players?limit=20`, commonPayload)
    const { data: playerData } = await playerResponse.json()

    const seriesId = '65ffec774c989ed97584bed8'
    const [editorPick, news] = await parallelCalls([
      queryGraphql(GET_CATEGORY_NEWS_VIDEOS, {
        input: {
          nLimit: 4,
          nSkip: 0,
          bEditorsPick: true,
          iCategoryId: seriesId,
          eType: 'n'
        }
      }),
      queryGraphql(GET_CATEGORY_NEWS_VIDEOS, {
        input: {
          nLimit: 24,
          nSkip: 0,
          iCategoryId: seriesId,
          eType: 'vn'
        }
      })
    ])

    return {
      props: {
        fixtureData,
        preViousWinnersData,
        teamData,
        news: news || {},
        editorPick: editorPick || {},
        playerData,
        seoData
      }
    }
  } catch (e) {
    console.error('Error fetching data:', e)
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}

HIL.propTypes = {
  news: PropTypes.object,
  editorPick: PropTypes.object,
  seoData: PropTypes.object,
  teamData: PropTypes.array,
  playerData: PropTypes.array,
  league: PropTypes.object,
  fixtureData: PropTypes.array,
  preViousWinnersData: PropTypes.array
}

export default HIL
